import { render, staticRenderFns } from "./EditMilestone.vue?vue&type=template&id=3838ff90"
import script from "./EditMilestone.vue?vue&type=script&lang=js"
export * from "./EditMilestone.vue?vue&type=script&lang=js"
import style0 from "./EditMilestone.vue?vue&type=style&index=0&id=3838ff90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports